module.exports = __webpack_public_path__ + "img/kl_SC.6a6119fd.jpg";